import { notification } from "antd";
import { useEffect, useRef, useState } from "react";
import SockJS from "sockjs-client/dist/sockjs";
import Stomp from "stompjs";

import { SOCKET_URL } from "@/api/apiConstants";
import i18next from "i18next";

const useSocketConnection = (params, id) => {
  const socketRef = useRef(null);
  const stompClientRef = useRef(null);
  const subscriptionRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    if (!id) return;

    const socketUrl = `${SOCKET_URL}?${params}=${id}`;
    socketRef.current = new SockJS(socketUrl);
    stompClientRef.current = Stomp.over(socketRef.current);
    stompClientRef.current.debug = null;

    const onConnect = () => {
      setIsConnected(true);
    };

    const onError = (error) => {
      console.warn("error: ", error);
      setIsConnected(false);
      // notification.error({
      //   message: i18next.t("inbox.socketConnectionFailed"),
      //   description: error
      // });
    };

    stompClientRef.current.connect({}, onConnect, onError);
  }, [id]);

  const subscribeChat = (callback) => {
    if (isConnected && !isSubscribed && stompClientRef.current) {
      subscriptionRef.current = stompClientRef.current.subscribe(
        "/user/chat",
        (message) => {
          const newChatMessage = JSON.parse(message.body);
          if (callback) {
            callback(newChatMessage);
          }
        }
      );
      setIsSubscribed(true);
    }
  };

  const unSubscribeChat = () => {
    if (isSubscribed && subscriptionRef.current) {
      subscriptionRef.current.unsubscribe();
      subscriptionRef.current = null;
      setIsSubscribed(false);
    }
  };

  const subscribeChatUsers = (callback) => {
    if (isConnected && !isSubscribed) {
      subscriptionRef.current = stompClientRef.current.subscribe(
        "/user/all-chats",
        (user) => {
          try {
            const updatedChatUser = JSON.parse(user.body);
            if (callback) {
              callback(updatedChatUser);
            }
          } catch (error) {
            notification.error({
              message: i18next.t("inbox.sidebarUsersFetchError")
            });
          }
        }
      );
      setIsSubscribed(true);
    }
  };

  const unSubscribeChatUser = () => {
    if (isSubscribed && subscriptionRef.current) {
      subscriptionRef.current.unsubscribe();
      subscriptionRef.current = null;
      setIsSubscribed(false);
    }
  };

  const subscribeNotify = (callback) => {
    if (isConnected && !isSubscribed) {
      // Unsubscribe previous subscription if it exists

      subscriptionRef.current = stompClientRef.current.subscribe(
        "/user/notify",
        (notification) => {
          try {
            const newNotification = JSON.parse(notification.body);
            if (callback) {
              callback(newNotification);
            }
          } catch (error) {
            notification.error({
              message: i18next.t("inbox.messagesFetchError")
            });
          }
        }
      );
      setIsSubscribed(true);
    }
  };

  return {
    isConnected,
    isSubscribed,
    setIsConnected,
    setIsSubscribed,
    subscribeChat,
    unSubscribeChat,
    subscribeChatUsers,
    unSubscribeChatUser,
    subscribeNotify,
    disconnect: () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
      if (stompClientRef.current && isConnected) {
        stompClientRef.current.disconnect();
        setIsConnected(false);
      }
    }
  };
};

export default useSocketConnection;
